/* Yup validation schemas */
import * as Yup from "yup";

/* Add a closed container form schema */
export const mediaIdetifierValidationSchema = Yup.object().shape({
  mediaIdentifier: Yup.string().required()
});
